import { render, staticRenderFns } from "./NotificationTable.vue?vue&type=template&id=40e68dc2&scoped=true&"
import script from "./NotificationTable.vue?vue&type=script&lang=js&"
export * from "./NotificationTable.vue?vue&type=script&lang=js&"
import style0 from "./NotificationTable.vue?vue&type=style&index=0&id=40e68dc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e68dc2",
  null
  
)

export default component.exports